import { Pharmacy } from "@/Common/Api/Pharmacy/Dto/Responses/Pharmacy";
import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryExternalProviderPreferredFaxNumberUpdate } from "./DirectoryExternalProviderPreferredFaxNumberUpdate";
import { DirectoryPreferredPharmacyUpdate } from "./DirectoryPreferredPharmacyUpdate";
import { IDirectoryEntity } from "./IDirectoryEntity";

class DirectoryEntityPatientLink {
    public patientContactId: string;
    public directoryEntity: IDirectoryEntity;
    public customPharmacy?: Pharmacy;
    public entityType: DirectoryEntityType;
    public selectedFaxNumberId?: string;

    public constructor(init?: DirectoryEntityPatientLink) {
        Object.assign(this, init);
    }
}

class DirectoryPatientLinkUpdate {
    public static async trigger<T extends DirectoryEntityPatientLink>(model: T): Promise<void> {
        switch (model?.entityType) {
            case DirectoryEntityType.HealthcareProvider:
                return await new DirectoryExternalProviderPreferredFaxNumberUpdate(model).trigger();

            case DirectoryEntityType.Pharmacy:
                return await new DirectoryPreferredPharmacyUpdate(model).trigger();

            default:
                return null;
        }
    }
}

export { DirectoryEntityPatientLink, DirectoryPatientLinkUpdate };
